<template>
  <SpmFunc
    :url="dateObject.downloadDetailUrl"
    spm="1003.2449.3001.8297"
    :index="index"
    :view="spmView"
    :report="spmClick"
  >
    <div class="pic_text-text">
      <div class="pic_text-content-img">
        <img :src="dateObject.image_url" alt="live" />
      </div>
      <div class="pic_text-detailed">
        <p class="pic_text-detailed-title">
          <span class="select">{{dateObject.title}}</span>
        </p>
        <p class="pic_text-detailed-content">{{dateObject.desc}}</p>
        <div class="father">
          <p class="pic_text-detailed-teacher" @click.stop>原创作者：{{dateObject.nickname}}</p>
          <p class="pic_text-detailed-span select" @click.stop>购买时间：{{dateObject.subscribeTime}}</p>
        </div>
      </div>
    </div>
  </SpmFunc>
</template>

<script>
import SpmFunc from "@/components/Base/SpmFunc.vue";

export default {
  components: {
    SpmFunc,
  },
  props: {
    dateObject: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  computed: {
    spmView() {
      let temp = {
        spm: "1003.2449.3001.7934",
        dest: this.dateObject.downloadDetailUrl,
        index: this.index,
      };
      return temp;
    },
    spmClick() {
      let temp = {
        spm: "1003.2449.3001.8297",
        dest: this.dateObject.downloadDetailUrl,
        index: this.index,
      };
      return temp;
    },
  },
};
</script>

<style lang="less" scoped>
.pic_text-text {
  display: flex;
  margin-bottom: 16px;
  cursor: pointer;

  .select {
    cursor: auto !important;
  }

  .pic_text-content-img {
    width: 88px;
    height: 88px;
    background: #f5f6f7;
    border-radius: 2px;
    margin-right: 12px;

    img {
      width: 88px;
      height: 88px;
      object-fit: cover;
      border-radius: 2px;
    }
  }
  .pic_text-detailed {
    display: flex;
    flex-direction: column;
    width: 666px;

    .pic_text-detailed-title {
      display: flex;
      width: 100%;
      font-weight: 500;
      color: #555666;
      line-height: 20px;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 4px 0 8px 0;
    }
    .pic_text-detailed-content {
      width: 100%;
      font-size: 12px;
      font-weight: 400;
      color: #555666;
      line-height: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 24px;
    }

    .father {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .pic_text-detailed-teacher {
        font-size: 12px;
        font-weight: 500;
        color: #222226;
        line-height: 16px;
      }
      .pic_text-detailed-span {
        font-size: 12px;
        font-weight: 400;
        color: #555666;
        line-height: 16px;
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .pic_text-detailed {
      width: calc(~"100% - 100px") !important;
    }
  }
}
</style>